function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.scrollX || document.documentElement.scrollLeft,
        scrollTop = window.scrollY || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let mainPosition = offset(document.querySelector('#content'));

// if(window.innerWidth > 960){
//     window.addEventListener('scroll', function() {
//         if(window.scrollY > menuPosition.top){
//             document.getElementById('header').classList.add('header--fixed');
//         }
//         else{
//             document.getElementById('header').classList.remove('header--fixed');
//         }
//     })
// }


let previousScrollTop = 0;

window.addEventListener('scroll', function() {
    
    if (window.innerWidth >= 961) {
    
        if(window.scrollY > ( mainPosition.top + 380 )){
            header.classList.add('header--fixed');
        }
        else{
            header.classList.remove('header--fixed');
        }
    
        let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

        if (currentScrollTop < previousScrollTop) {
            // Scrolling vers le haut
            if (currentScrollTop > 130) {
                header.classList.add('header--up')
                header.classList.remove('header--down')
            }
        }
        else {
            // Scrolling vers le bas
            header.classList.add('header--down')
            header.classList.remove('header--up')
        }
    
        // Supprimer les classes en haut de la page pour que le header reprenne sa forme initiale
        if (currentScrollTop <= 130) {
            header.classList.remove('header--up')
            header.classList.remove('header--down')
        }
    
        previousScrollTop = currentScrollTop;
    }
});
